/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FeatureType {
    AdminPortalAccess = 'AdminPortalAccess',
    SearchManager = 'SearchManager',
    BookingCreateOsisRule = 'BookingCreateOsisRule',
    BookingCreateRemarkRule = 'BookingCreateRemarkRule',
    Markups = 'Markups',
    GlobalFilterRules = 'GlobalFilterRules',
    TicketTimeLimitOverride = 'TicketTimeLimitOverride',
    ProviderCredentials = 'ProviderCredentials',
    ProviderPreferences = 'ProviderPreferences',
    IdentityProviderSettings = 'IdentityProviderSettings',
    IdentitySettings = 'IdentitySettings',
    Agencies = 'Agencies',
    AgencyGroups = 'AgencyGroups',
    Regions = 'Regions',
    Countries = 'Countries',
    Cities = 'Cities',
    Airports = 'Airports',
    Brands = 'Brands',
    Markets = 'Markets',
    DistributionChannels = 'DistributionChannels',
    UserPermissions = 'UserPermissions',
    Airlines = 'Airlines',
    Agents = 'Agents',
    SupplierLocationMappings = 'SupplierLocationMappings',
    SearchManagerDiagnostics = 'SearchManagerDiagnostics',
    ShoppingDiagnostics = 'ShoppingDiagnostics',
    TechnicalLogs = 'TechnicalLogs',
    MarkupDiagnostics = 'MarkupDiagnostics',
    GlobalFilterDiagnostics = 'GlobalFilterDiagnostics',
    ActivityLog = 'ActivityLog',
    Providers = 'Providers',
    AncillarySuppliers = 'AncillarySuppliers',
    AncillaryManager = 'AncillaryManager',
    AncillaryDistributions = 'AncillaryDistributions',
    VccCredentials = 'VccCredentials',
    SSRRules = 'SSRRules',
    BookingTolerances = 'BookingTolerances'
}

export function FeatureTypeFromJSON(json: any): FeatureType {
    return FeatureTypeFromJSONTyped(json, false);
}

export function FeatureTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureType {
    return json as FeatureType;
}

export function FeatureTypeToJSON(value?: FeatureType | null): any {
    return value as any;
}

